function getModelsPerRow(breakpoint, cardSizeSetting) {
  if (cardSizeSetting === 'small') {
    return {
      sm: 2,
      md: 5,
      lg: 5,
      xl: 6,
      xxl: 7,
    }[breakpoint] ?? 1
  }

  if (cardSizeSetting === 'large') {
    return {
      sm: 2,
      md: 3,
      lg: 3,
      xl: 4,
      xxl: 5,
    }[breakpoint] ?? 1
  }

  return {
    sm: 2,
    md: 4,
    lg: 4,
    xl: 5,
    xxl: 6,
  }[breakpoint] ?? 1
}

export default getModelsPerRow
